import { defineStore } from "pinia";
import { ref } from "vue";

export const useAlertStore = defineStore("alerts", () => {
  const targetComponent = ref("");
  const snackStatus = ref(false);
  const snackMsg = ref("Success!");
  const snackColor = ref("red-darken-2");
  const snackDelayInMilliseconds = ref(0);

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  const snackWarn = async (
    msg: string,
    delayInMilliseconds: number = 0,
    target: string = "login",
  ) => {
    await sleep(delayInMilliseconds);
    targetComponent.value = target;
    snackColor.value = "warning";
    snackMsg.value = msg;
    snackStatus.value = true;
    snackDelayInMilliseconds.value = delayInMilliseconds;
    return snackColor.value;
  };

  const snackSuccess = async (msg: string, delayInMilliseconds: number = 0) => {
    await sleep(delayInMilliseconds);
    snackColor.value = "success";
    snackMsg.value = msg;
    snackStatus.value = true;
    snackDelayInMilliseconds.value = delayInMilliseconds;
    return snackColor.value;
  };

  const alertTarget = ref("");
  const alertStatus = ref(false);
  const alertMsg = ref("Success!");
  const alertTitle = ref("");
  const alertType = ref<"success" | "error" | "warning" | "info" | undefined>(
    "success",
  );

  function alertWarn(msg: string, target: string = "") {
    alertType.value = "warning";
    alertStatus.value = true;
    alertMsg.value = msg;
    alertTarget.value = target;
  }

  return {
    snackSuccess,
    snackWarn,
    snackDelayInMilliseconds,
    snackStatus,
    snackMsg,
    snackColor,
    alertStatus,
    alertMsg,
    alertTitle,
    alertType,
    alertWarn,
    alertTarget,
  };
});
